// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tVx2","left":"styles_left__1VFfQ","right":"styles_right__W7Jgd","alert":"styles_alert__2epUt"};